import { connect } from 'react-redux';
import WorkWithUsComponent from '../components/WorkWithUsComponent';
import { sendCurriculum } from '../actions/WorkWithUsActions';

const mapStateToProps = (state) => ({
    submitting: state.workWithUs.submitting,
    submitted: state.workWithUs.submitted,
});

const mapDispatchToProps = (dispatch) => ({
    sendCurriculum: (data) => {
        dispatch(sendCurriculum(data));
    },
});

const WorkWithUsContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(WorkWithUsComponent);

export default WorkWithUsContainer;
